import { Component, Inject, OnInit } from '@angular/core';
import { ContentBlockComponent } from "../../component/content-block/content-block.component";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgIf } from "@angular/common";
import { ConfigService } from "../../common/service/config.service";

@Component({
  selector: 'app-disabled',
  standalone: true,
  imports: [
    ContentBlockComponent,
    FormsModule,
    NgIf,
    ReactiveFormsModule
  ],
  templateUrl: './disabled.component.html'
})
export class DisabledComponent implements OnInit {

  config: any;
  boothMode: boolean = false;

  constructor(
    private configService: ConfigService,
    @Inject('Storage') protected storage: Storage
  ) {
    this.boothMode = this.storage.getItem('forceBoothMode') === 'true';
  }

  ngOnInit(): void {
    this.configService.config$.subscribe((config) => {
      this.config = config;
    });
  }

  getLogoUrl() {
    return this.config?.logoUrl || '';
  }
}
